import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import SocialHandle from "../../Common/SocialHandles/SocialHandle";
import { Element } from "react-scroll";
import {
  aboutMe,
  development,
  approach,
} from "../../../assets/text/AboutMeText";
import classes from "./about.module.css";

const AboutMe = React.memo(() => {
  const sectionRef = useRef(null);

  const { scrollYProgress } = useScroll({
    target: sectionRef,
    offset: ["start end", "end start"],
  });

  // Heading slides in from left with parallax
  const headingX = useTransform(scrollYProgress, [0, 0.3], [-60, 0]);
  const headingOpacity = useTransform(scrollYProgress, [0, 0.25], [0, 1]);

  const cardVariants = {
    hidden: { opacity: 0, y: 50, scale: 0.95 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      scale: 1,
      transition: {
        duration: 0.7,
        delay: i * 0.2,
        ease: [0.4, 0, 0.2, 1],
      },
    }),
  };

  return (
    <Element name="About">
      <div className={classes.AboutMe} ref={sectionRef}>
        <motion.div
          className={classes.AboutMeHeading}
          style={{ x: headingX, opacity: headingOpacity }}
        >
          <p className={classes.AboutMeSubHeading}>About Me</p>
          <p className={classes.AboutMeWriteUp}>
            I build modern, responsive, and user-friendly websites using the
            latest web technologies and best development practices.
          </p>
          <div className={classes.AboutSocialHandlesPC}>
            <SocialHandle />
          </div>
        </motion.div>

        <div className={classes.AboutMeDetails}>
          {/* About Me Section */}
          <motion.div
            custom={0}
            initial="hidden"
            whileInView="visible"
            variants={cardVariants}
            viewport={{ once: true, amount: 0.3 }}
          >
            <p>{aboutMe}</p>
          </motion.div>

          {/* Why Development Section */}
          <motion.div
            custom={1}
            initial="hidden"
            whileInView="visible"
            variants={cardVariants}
            viewport={{ once: true, amount: 0.3 }}
          >
            <h4>Why Development?</h4>
            <p>{development}</p>
          </motion.div>

          {/* My Approach Section */}
          <motion.div
            custom={2}
            initial="hidden"
            whileInView="visible"
            variants={cardVariants}
            viewport={{ once: true, amount: 0.3 }}
          >
            <h4>My Approach</h4>
            <p>{approach}</p>
          </motion.div>
        </div>
      </div>
    </Element>
  );
});

export default AboutMe;
